import Option from "@JohnLewisPartnership/jl-design-system/dist/components/option/Option";
import { useState } from "react";
import { SaleTagIcon } from "../../__shared__/SaleTagIcon/SaleTagIcon";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import styles from "./DeliveryServiceItem.module.scss";

type Props = {
  checked: boolean;
  description: string;
  disabled: boolean;
  display: string;
  serviceId: string;
  title: string;
  toggleCheck: (serviceId: string) => void;
  value: number;
  key: string;
  showFreeServicePromoTag: boolean;
};

export const DeliveryServiceItem = ({
  checked,
  description,
  disabled,
  display,
  serviceId,
  title,
  toggleCheck,
  value,
  key,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const isFree = value === 0;

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);
  const handleToggleCheckClick = () => toggleCheck(serviceId);

  const freeLabel = (
    <div
      className={styles.tagBadge}
      data-testid="product:delivery-service:free-badge"
    >
      <SaleTagIcon type="small" />
      <p>Free</p>
    </div>
  );

  return (
    <div
      id="product:delivery-service"
      data-testid="product:delivery-service"
      className={styles.deliveryServiceItemWrapper}
    >
      <div className={styles.serviceItem}>
        <Option
          type="checkbox"
          isControlled={true}
          className={styles.serviceInfo}
          id={serviceId}
          ariaLabel={title}
          label={title}
          checked={checked}
          onClick={handleToggleCheckClick}
          name={title}
          value={""}
          additionalInfo={isFree ? freeLabel : display}
          disabled={disabled}
          autoComplete="off"
          auto
        />
        <IconButton
          icon={InfoOutlined}
          aria-label={`${title} information`}
          data-testid="product:delivery-service:tooltip:button:expand"
          onClick={handleTooltipExpandClick}
          className={styles.serviceToolTip}
          aria-expanded={showInfo}
          aria-controls={key}
          background="clear"
        />
      </div>
      <div
        id={key}
        data-testid="product:delivery-service:tooltip"
        className={styles.infoBlock}
        hidden={!showInfo}
      >
        <div aria-live="polite" className={styles.tip}>
          <h4 className={styles.title}>{title}</h4>
          <div dangerouslySetInnerHTML={{ __html: `${description}` }} />
        </div>
        <IconButton
          icon={CloseOutlined}
          aria-label={"Collapse tooltip"}
          data-testid="product:delivery-service:tooltip:button:collapse"
          className={styles.closeButton}
          onClick={handleTooltipCollapseClick}
          background="clear"
        />
      </div>
    </div>
  );
};
